// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1a9tz","load8":"Spinner_load8__3IFft","Loader--white":"Spinner_Loader--white__36TU7","Loader--secondary":"Spinner_Loader--secondary__2Ls7K"};